// Breakpoints!

/**
 * The sorts that are supported by this component.  This represents what's available in the clickable icon.
 *
 * @type {Object}
 */
export const ICON_SORTS = {
  SORT_ASCENDING: 'asc',
  SORT_DESCENDING: 'desc'
};

/**
 * The upper limit for the medium screen-width breakpoint ( small screen <= medium screen <= this number)
 *
 * @type {number}
 */
export const MEDIUM_UPPER_LIMIT_BREAKPOINT = 768;

/**
 * The upper limit for the small screen-width breakpoint ( small screen <= this number)
 *
 * @type {number}
 */

export const SMALL_UPPER_LIMIT_BREAKPOINT = 375;


// Buttons!

/**
 * The base class for the Live Style Guide button
 *
 * @type {string}
 */
export const BUTTON_CLASS = 'LSG-c-button';

/**
 * Other classes based on the main BUTTON_CLASS
 *
 * @type {string}
 */
const BUTTON_PRIMARY_REGULAR_CLASS = BUTTON_CLASS + '--primary-regular';
const BUTTON_PRIMARY_REGULAR_WIDE_CLASS = BUTTON_CLASS + '--primary-regular-wide';
const BUTTON_PRIMARY_REGULAR_FULL_WIDTH_CLASS = BUTTON_CLASS + '--primary-regular-full-width';
const BUTTON_PRIMARY_SMALL_CLASS = BUTTON_CLASS + '--primary-small';
const BUTTON_PRIMARY_SMALL_WIDE_CLASS = BUTTON_CLASS + '--primary-small-wide';
const BUTTON_PRIMARY_SMALL_FULL_WIDTH_CLASS = BUTTON_CLASS + '--primary-small-full-width';
const BUTTON_SECONDARY_REGULAR_CLASS = BUTTON_CLASS + '--secondary-regular';
const BUTTON_SECONDARY_REGULAR_WIDE_CLASS = BUTTON_CLASS + '--secondary-regular-wide';
const BUTTON_SECONDARY_REGULAR_FULL_WIDTH_CLASS = BUTTON_CLASS + '--secondary-regular-full-width';
const BUTTON_SECONDARY_SMALL_CLASS = BUTTON_CLASS + '--secondary-small';
const BUTTON_SECONDARY_SMALL_WIDE_CLASS = BUTTON_CLASS + '--secondary-small-wide';
const BUTTON_SECONDARY_SMALL_FULL_WIDTH_CLASS = BUTTON_CLASS + '--secondary-small-full-width';
const BUTTON_TERTIARY_SMALL_CLASS = BUTTON_CLASS + '--tertiary-small';
const BUTTON_TERTIARY_REGULAR_CLASS = BUTTON_CLASS + '--tertiary-regular';
const BUTTON_DISABLED_CLASS = BUTTON_CLASS + '--disabled';

/**
 * An object containing the various button types
 *
 * @type {object}
 */
export const BUTTON_TYPES = {
  PRIMARY_REGULAR: 'primary-regular',
  PRIMARY_REGULAR_WIDE: 'primary-regular-wide',
  PRIMARY_REGULAR_FULL_WIDTH: 'primary-regular-full-width',
  PRIMARY_SMALL: 'primary-small',
  PRIMARY_SMALL_WIDE: 'primary-small-wide',
  PRIMARY_SMALL_FULL_WIDTH: 'primary-small-full-width',
  SECONDARY_REGULAR: 'secondary-regular',
  SECONDARY_REGULAR_WIDE: 'secondary-regular-wide',
  SECONDARY_REGULAR_FULL_WIDTH: 'secondary-regular-full-width',
  SECONDARY_SMALL: 'secondary-small',
  SECONDARY_SMALL_WIDE: 'secondary-small-wide',
  SECONDARY_SMALL_FULL_WIDTH: 'secondary-small-full-width',
  TERTIARY_REGULAR: 'tertiary-regular',
  TERTIARY_SMALL: 'tertiary-small',
  DISABLED: 'disabled'
};

/**
 * Represents the buttonType -> buttonClass relationship map
 *
 * @type {object}
 */
export const BUTTON_TYPES__BUTTON_CLASS_MAP = {
  [BUTTON_TYPES.PRIMARY_REGULAR]: BUTTON_PRIMARY_REGULAR_CLASS,
  [BUTTON_TYPES.PRIMARY_REGULAR_WIDE]: BUTTON_PRIMARY_REGULAR_WIDE_CLASS,
  [BUTTON_TYPES.PRIMARY_REGULAR_FULL_WIDTH]: BUTTON_PRIMARY_REGULAR_FULL_WIDTH_CLASS,
  [BUTTON_TYPES.PRIMARY_SMALL]: BUTTON_PRIMARY_SMALL_CLASS,
  [BUTTON_TYPES.PRIMARY_SMALL_WIDE]: BUTTON_PRIMARY_SMALL_WIDE_CLASS,
  [BUTTON_TYPES.PRIMARY_SMALL_FULL_WIDTH]: BUTTON_PRIMARY_SMALL_FULL_WIDTH_CLASS,
  [BUTTON_TYPES.SECONDARY_REGULAR]: BUTTON_SECONDARY_REGULAR_CLASS,
  [BUTTON_TYPES.SECONDARY_REGULAR_FULL_WIDTH]: BUTTON_SECONDARY_REGULAR_FULL_WIDTH_CLASS,
  [BUTTON_TYPES.SECONDARY_REGULAR_WIDE]: BUTTON_SECONDARY_REGULAR_WIDE_CLASS,
  [BUTTON_TYPES.SECONDARY_SMALL]: BUTTON_SECONDARY_SMALL_CLASS,
  [BUTTON_TYPES.SECONDARY_SMALL_WIDE]: BUTTON_SECONDARY_SMALL_WIDE_CLASS,
  [BUTTON_TYPES.SECONDARY_SMALL_FULL_WIDTH]: BUTTON_SECONDARY_SMALL_FULL_WIDTH_CLASS,
  [BUTTON_TYPES.TERTIARY_REGULAR]: BUTTON_TERTIARY_REGULAR_CLASS,
  [BUTTON_TYPES.TERTIARY_SMALL]: BUTTON_TERTIARY_SMALL_CLASS,
  [BUTTON_TYPES.DISABLED]: BUTTON_DISABLED_CLASS
};
